export function getCustomFieldsPayload(sections) {
  let customFields = [];

  sections?.forEach((section) => {
    section?.custom_fields?.forEach((field) => {
      let obj = {
        custom_field_id: field.id,
        type: section.type,
      };
      if (field.type === "checkboxes" && field.value?.length)
        obj.value = JSON.stringify(field.value);
      else if (
        field.type !== "checkboxes" &&
        (field.value || field.type === "toggleButton")
      ) {
        obj.value =
          field.type === "toggleButton" ? (field.value ? 1 : 0) : field.value;
      }
      customFields.push(obj);
    });
  });

  return customFields;
}
